const BUY_IT_AGAIN_CONSTANTS = {
  BUY_IT_AGAIN_PRODUCTS_START: 'BUY_IT_AGAIN_PRODUCTS_START',
  BUY_IT_AGAIN_PRODUCTS_SUCCESS: 'BUY_IT_AGAIN_PRODUCTS_SUCCESS',
  GET_BUY_IT_AGAIN_PRODUCTS_CACHE: 'GET_BUY_IT_AGAIN_PRODUCTS_CACHE',
  GET_MORE_BIA_PRODUCTS: 'GET_MORE_BIA_PRODUCTS',
  SET_INITIAL_PRODUCTS_LOADED: 'SET_INITIAL_PRODUCTS_LOADED',
  SET_BIA_PAGE_PRODUCTS: 'SET_BIA_PAGE_PRODUCTS',
  FETCH_BIA_PAGE_PRODUCTS: 'FETCH_BIA_PAGE_PRODUCTS',
  SET_BIA_IS_LOADING_MORE: 'SET_BIA_IS_LOADING_MORE',
  SET_BIA_TOTAL_PRODUCTS_COUNT: 'SET_BIA_TOTAL_PRODUCTS_COUNT',
  CLEAR_BIA_CACHE: 'CLEAR_BIA_CACHE',
  BUY_IT_AGAIN_PRODUCTS_FAILURE: 'BUY_IT_AGAIN_PRODUCTS_FAILURE',
  RESET_BIA: 'RESET_BIA',
  SET_BIA_LOADING: 'SET_BIA_LOADING',
  SET_BIA_PAGE_LOADING: 'SET_BIA_PAGE_LOADING',
  SET_CD66: 'SET_CD66',
  CLEAR_CD66: 'CLEAR_CD66',
  SET_BIA_INITIAL_API_ACTUAL_PRODUCTS_COUNT: 'SET_BIA_INITIAL_API_ACTUAL_PRODUCTS_COUNT',
  SET_BIA_API_RESPONSE: 'SET_BIA_API_RESPONSE',
};

// Buy It Again Component Constants.
export const buyItAgainPath = 'account/buy-it-again';

// Buy It Again Abstractor Constants.
export const BIA_SUFFIX = 'BIA';
export const BIA_DEFAULT_CACHE_KEY = 'BIA-ALL';
export const BIA_TOTAL = 'BIA_TOTAL';
export const LOAD_NEXT_PAGE_PRODUCTS = 20;
export const PROD_PART_NO = 'prodpartno';
export const TCP_PREV_STYLE = 'TCPPreviousStyle';
export const OR_SEPARATOR = ' OR ';

// Buy It Again Page Constants.
export const NEXT_PAGE_LOAD_OFFSET = 400;
export const THROTTLE_TIME = 100;

export default BUY_IT_AGAIN_CONSTANTS;
